import { getCurrentAccessToken, isAccessTokenValid } from "./refreshSession";

let lastSentToken = null;

// L'auth del socket e' una funzione che socket.io invoca a ogni tentativo di
// connessione: invia sempre il token e la cantina CORRENTI e ricorda quale
// token ha usato l'ultimo tentativo. Un oggetto `socket.auth = {token}` non
// permette di sapere con quale token e' fallito un connect_error.
export const configureSocketAuth = (socket, { getToken, getWineryId }) => {
  socket.auth = (cb) => {
    const token = getToken();
    lastSentToken = token;
    cb({ token, wineryId: getWineryId() });
  };
};

// connect_error per token scaduto: se il tentativo fallito usava un token
// diverso dal corrente (un refresh e' gia' avvenuto nel frattempo) e il
// corrente e' valido, basta riconnettere: niente nuovo refresh/rotazione.
export const shouldReconnectWithCurrentToken = (currentToken = getCurrentAccessToken()) =>
  !!lastSentToken &&
  !!currentToken &&
  lastSentToken !== currentToken &&
  isAccessTokenValid(currentToken);
